import React, { useState, useEffect } from "react";
import { Form, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const Pagination = ({ currentPage, totalPages, handlePreviousPage, handleNextPage, handlePageChange }) => {
  const [inputPage, setInputPage] = useState(currentPage);

  useEffect(() => {
    setInputPage(currentPage); // Sync input with external changes
  }, [currentPage]);

  const onInputChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^[0-9\b]+$/.test(value)) {
      setInputPage(value);
    }
  };
  

  // const onInputBlur = () => {
  //   const page = parseInt(inputPage);
  //   if (!isNaN(page) && page >= 1 && page <= totalPages && page !== currentPage) {
  //     handlePageChange(page);
  //   } else {
  //     setInputPage(currentPage); // Reset if invalid
  //   }
  // };

  const onInputBlur = () => {
    const page = parseInt(inputPage);
    if (isNaN(page) || page < 1) {
      setInputPage(currentPage); // Reset if invalid or < 1
    } else if (page > totalPages) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Page',
        text: `Please enter a page number between 1 and ${totalPages}.`,
        confirmButtonColor: '#3085d6'
      }).then(() => {
        setInputPage(currentPage); // Reset after alert
        // handlePageChange(currentPage);
      });
    } else if (page !== currentPage) {
      handlePageChange(page);
    }
  };  

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onInputBlur();
    }
  };

  return (
    <>
    <Col style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <Form.Control
        type="number"
        min={1}
        max={totalPages}
        value={inputPage}
        onChange={onInputChange}
        onBlur={onInputBlur}
        onKeyPress={onKeyPress}
        style={{ width: "55px", padding: "2px 6px" }}
      />
      <Form.Label className="FormLabel" style={{ marginBottom: 0 }}>
        of {totalPages}
      </Form.Label>

      {currentPage > 1 ? (
        <Form.Label className="FormLabel" onClick={handlePreviousPage} style={{ cursor: "pointer", marginBottom: 0 }}>
          <FontAwesomeIcon icon={faChevronLeft} style={{ color: "#ffffff" }} />
        </Form.Label>
      ) : (
        <Form.Label className="FormLabel" style={{ color: "#cccccc", marginBottom: 0 }}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </Form.Label>
      )}

      {currentPage < totalPages ? (
        <Form.Label className="FormLabel" onClick={handleNextPage} style={{ cursor: "pointer",  marginBottom: 0 }}>
          <FontAwesomeIcon icon={faChevronRight} style={{ color: "#ffffff" }} />
        </Form.Label>
      ) : (
        <Form.Label className="FormLabel" style={{ color: "#cccccc", marginBottom: 0 }}>
          <FontAwesomeIcon icon={faChevronRight} />
        </Form.Label>
      )}
    </Col>

    <div><br /></div>
    </>
  );
};

export default Pagination;